import type { MessageKey } from '@bookingdei/i18n/message-key';

// An audit row's `actor_role` (AuditLogEntry) as the reader's label ("Merchant" /
// "মার্চেন্ট"). The five roles the audit log writes have a label; anything else is a
// code and shows as sent (DC122 — raw role codes leaked into the bn UI).
const ROLES = ['customer', 'merchant', 'staff', 'admin', 'system'] as const;

export function actorRoleLabel(t: (key: MessageKey) => string, role: string | null | undefined): string {
  if (!role) return '';
  return (ROLES as readonly string[]).includes(role) ? t(`admin.rpt.role.${role}` as MessageKey) : role;
}
